<template>
  <div>
    <v-row class="mx-0 mt-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-text-field
          disabled
          class="pa-0 pt-2 ma-0"
          v-model="confirmData.login"
          label="Электронная почта"
        />
      </v-col>

      <v-col cols="12" class="pa-0 ma-0">
        <v-text-field
          class="pt-3 ma-0"
          v-model="confirmData.password.value"
          label="Пароль"
          :type="confirmData.password.type"
          required
          :append-icon="confirmData.password.icon"
          @click:append="confirmData.password.changeVisible()"
          :error-messages="passwordErrors"
          @input="$v.confirmData.password.value.$touch()"
          @blur="$v.confirmData.password.value.$touch()"
        />
      </v-col>

      <v-col cols="12" class="pa-0 ma-0">
        <v-text-field
          class="pt-3 ma-0"
          v-model="confirmData.passwordConfirm.value"
          label="Подтверждение пароля"
          :type="confirmData.passwordConfirm.type"
          :append-icon="confirmData.passwordConfirm.icon"
          @click:append="confirmData.passwordConfirm.changeVisible()"
          :error-messages="passwordConfirmErrors"
          @input="$v.confirmData.passwordConfirm.value.$touch()"
          @blur="$v.confirmData.passwordConfirm.value.$touch()"
        />
      </v-col>
    </v-row>

    <v-row class="mx-0 mb-0">
      <v-col cols="4" class="pa-0 mt-4">
        <v-btn
          depressed
          color="primary"
          class="mr-2"
          :loading="loading"
          :disabled="$v.$invalid"
          @click="confirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-col>

      <v-col cols="8" class="pa-0 mt-5 d-flex justify-end">
        <v-btn text small color="primary" class="pr-2" to="/login">
          Страница входа
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { authApi } from '@/api'
import { mapGetters } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import { Registration } from '@/models'

export default {
  name: 'PasswordCreate',

  props: {
    confirmParams: {
      type: Object,
      required: true
    },

    type: {
      type: String, // может быть 'forget' или 'registration'
      required: true
    }
  },

  created() {
    this.setConfirmData()
  },

  data: () => ({
    loading: false,
    confirmData: new Registration()
  }),

  validations() {
    return {
      confirmData: {
        password: {
          value: {
            required
          }
        },

        passwordConfirm: {
          value: {
            sameAs: sameAs(() => this.confirmData.password.value)
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters('user', ['isOperatorRoles']),

    confirmText() {
      if (this.type === 'registration') return "Зарегистрироваться"
      if (this.type === 'forget') return "Сохранить пароль"
    },

    passwordErrors() {
      const errors = []
      if (!this.$v.confirmData.password.value.$dirty) return errors
      !this.$v.confirmData.password.value.required && errors.push('Пароль не может быть пустым')
      return errors
    },

    passwordConfirmErrors() {
      const errors = []
      if (!this.$v.confirmData.passwordConfirm.value.$dirty) return errors
      !this.$v.confirmData.passwordConfirm.value.sameAs && errors.push("Пароли не совпадают")
      return errors
    }
  },

  methods: {
    setConfirmData() {
      this.confirmData.login = this.confirmParams.login
      this.confirmData.code = this.confirmParams.code
    },

    async confirm() {
      try {
        this.loading = true

        console.log(this.confirmData)

        const body = {
          ...this.confirmData,
          username: this.confirmData.login,
          password: this.confirmData.password.value,
          passwordConfirm: this.confirmData.passwordConfirm.value
        }

        const loginBody = {
          username: this.confirmData.login,
          password: this.confirmData.password.value
        }

        switch (this.type) {
          case 'registration':
            await this.confirmRegistration(body)
            break
          case 'forget':
            await this.confirmReset(body)
        }

        await this.$store.dispatch('user/login', loginBody)

        this.isOperatorRoles
          ? await this.$router.push('/')
          : this.$toastr('error', '', 'Обратитесь к администратору для получения прав доступа')

        const data = await this.$store.dispatch('user/login', loginBody)

        if (data.username) {
          await this.$router.push('/')
        }
      } catch (e) {

      } finally {
        this.loading = false
      }
    },

    async confirmRegistration(body) {
      try {
        await authApi.confirmRegistration(body)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка подтверждения регистрации')
        return Promise.reject(e)
      }
    },

    async confirmReset(body) {
      try {
        await authApi.confirmReset(body)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка подтверждения сброса пароля')
        return Promise.reject(e)
      }
    }
  }
}
</script>